export default __webpack_public_path__ + "static/media/telegram-s-icon.76829774.svg";